module.exports = "/images/bomb.png?41081d2bb01e2dbd2d3d330bc3bcc2e3";